// extracted by mini-css-extract-plugin
module.exports = {"blogContainer":"Blog_blogContainer__2T99B","element1":"Blog_element1__1_y7A","element2":"Blog_element2__3r-j4"};